import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary, RaikoCreatorInfo,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, RaikoSimpleMultiLineInputOutlined,
    RaikoToggleOutlined, showPromiseToast, showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {css} from "@emotion/css";
import {AppVersionService} from "../../serverService/appVersionService/AppVersionService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import AndroidFileBox from "./androidFileBox/AndroidFileBox";
import {useRaikoUploadManager} from "../../raikoComponents/raikoUploader/RaikoUploadManagerContext";
import {RaikoUploadFileTypes} from "../../raikoComponents/raikoUploader/RaikoUploadFileTypes";

export default function AppVersionDetail() {

    const navigate = useNavigate()
    const {state} = useLocation()
    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.AppVersionDetail.name);
    const {id: appVersionId} = useParams()

    const service = new AppVersionService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [title, setTitle] = useState("");
    const [versionNumber, setVersionNumber] = useState(0);
    const [minimumVersionNumber, setMinimumVersionNumber] = useState(0);
    const [enabled, setEnabled] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(false);
    const [cafebazaarReleaseStatus, setCafebazaarReleaseStatus] = useState(false);
    const [description, setDescription] = useState("");

    const [basicInfoLoading, setBasicInfoLoading] = useState(false)

    const [createdBy, setCreatedBy] = useState("")
    const [createdAt, setCreatedAt] = useState("")

    const [apkUrl, setApkUrl] = useState(null)
    const [apkTitle, setApkTitle] = useState(null)
    const [apkFile, setApkFile] = useState(null)

    useEffect(() => {
        loading.show()
        service.getAppVersionDetail(appVersionId)
            .then(response => {
                setTitle(response.name)
                setVersionNumber(response.versionNumber)
                setMinimumVersionNumber(response.latestValidVersionNumber)
                setCafebazaarReleaseStatus(response.storePublished)
                setEnabled(response.enabled)
                setForceUpdate(response.mandatory)
                setApkUrl(response.apk.downloadUrl)
                setApkTitle(response.apk.downloadUrl ? response.name : null)
                setDescription(response.metaData && response.metaData.description ? response.metaData.description : "")

                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
                setCreatedBy(response.createdBy)

            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }, []);


    function handleUpdateInfo() {
        setBasicInfoLoading(true)
        service.updateAppVersion(
            appVersionId,
            title,
            versionNumber,
            minimumVersionNumber,
            enabled,
            cafebazaarReleaseStatus,
            forceUpdate,
            description
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setBasicInfoLoading(false)
        })
    }

    const {startUpload} = useRaikoUploadManager()

    function handleUpdateApkVersion() {
        if (apkFile) {
            startUpload(
                apkFile,
                service.uploadApkFile,
                appVersionId,
                RaikoUploadFileTypes.APK
            )
        } else
            showWarningMessage("لطفا ابتدا نسخه ی جدید را انتخاب نمایید.")
    }

    return (
        <>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[

                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.AppVersionList.name,
                                    RouteHelper.AppVersionList.globalUrl
                                ),
                                raikoBreadCrumbItemGenerator(
                                    pageTitle,
                                    ""
                                ),
                            ]}/>

                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>
                    </RaikoFlexFirstChildGrowOne>


                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            hasActionButton
                            title={"نسخه APK"}
                            actionButtonOnclick={handleUpdateApkVersion}
                        >
                            <AndroidFileBox
                                setTitle={setApkTitle}
                                file={apkFile}
                                title={apkTitle}
                                url={apkUrl}
                                setFile={setApkFile}
                            />
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>

                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"اطلاعات پایه"}
                            hasActionButton
                            actionButtonOnclickWithValidation={handleUpdateInfo}
                            actionButtonLoadingState={basicInfoLoading}
                        >
                            <RaikoGridThreeColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"نام نسخه"}
                                    value={title}
                                    setValue={setTitle}
                                    required
                                />
                                <RaikoNumberInputOutlined
                                    labelText={"شماره نسخه"}
                                    value={versionNumber}
                                    setValue={setVersionNumber}
                                    required
                                />
                                <RaikoNumberInputOutlined
                                    labelText={"حداقل شماره نسخه"}
                                    value={minimumVersionNumber}
                                    setValue={setMinimumVersionNumber}
                                    required
                                />
                                <RaikoToggleOutlined
                                    checked={enabled}
                                    setChecked={setEnabled}
                                    labelText={"منتشر شده / پیش نویس"}
                                />
                                <RaikoToggleOutlined
                                    checked={forceUpdate}
                                    setChecked={setForceUpdate}
                                    labelText={"نوع بروزرسانی ( اجباری/اختیاری)"}
                                />
                                <RaikoToggleOutlined
                                    checked={cafebazaarReleaseStatus}
                                    setChecked={setCafebazaarReleaseStatus}
                                    labelText={"انتشار کافه بازار (منتشر شده / در حال انتشار)"}
                                />
                            </RaikoGridThreeColumn>
                            <RaikoSimpleMultiLineInputOutlined
                                labelText={"توضیحات"}
                                value={description}
                                setValue={setDescription}
                                required
                            />
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>


                    <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}